import { Controller } from 'stimulus'

export default class ModalController extends Controller {
  static targets = ['content', 'container']

  connect() {
    if($(this.containerTarget).data('instant'))
      this.showModal()
  }

  show(event) {
    event.preventDefault()
    this.showModal()
  }

  showModal() {
    $(this.contentTarget)
      .modal({
        context: $(this.containerTarget),
      })
      .modal('show')
  }
}
